module.exports = __webpack_public_path__ + "img/access_colour_method_button.ad27648f.jpg";